import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../auth/auth-guard.service';
import { ProductComponent } from './product/product.component';
import { CompetitorPositioningComponent } from './competitor-positioning/competitor-positioning.component';
import { ProductGeneralComponent } from './product-general/product-general.component';
import { ProductTrainingMaterialsComponent } from './product-training-materials/product-training-materials.component';
import { ProductMarketingMaterialsComponent } from './product-marketing-materials/product-marketing-materials.component';
import { ProductCompetitorsComponent } from './product-competitors/product-competitors.component';
import { ProductReferencesComponent } from './product-references/product-references.component';
import { ProductProposalComponent } from './product-proposal/product-proposal.component';
import { ProductSubscriptionsComponent } from './product-subscriptions/product-subscriptions.component';

const productRoutes: Routes = [
    {
    path: 'products/product/:id/:name',
    component: ProductComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: '', redirectTo: 'general', pathMatch: 'full' },
      { path: 'general', component: ProductGeneralComponent },
      { path: 'training-materials', component: ProductTrainingMaterialsComponent },
      { path: 'marketing-materials', component: ProductMarketingMaterialsComponent },
      { path: 'competitors', component: ProductCompetitorsComponent },
      { path: 'references', component: ProductReferencesComponent },
      { path: 'subscriptions', component: ProductSubscriptionsComponent },
      { path: 'value-proposal', component: ProductProposalComponent },
    ]
  },
  {
    path: 'products/product/:id/:name/competitor/:competitorId/:competitorName/positioning',
    component: CompetitorPositioningComponent,
    canActivate: [AuthGuardService]
  }
 ];

@NgModule({
  imports: [RouterModule.forChild(productRoutes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
